import { Col, List, Row, Timeline, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledListItem = styled(List.Item)`
  padding: 6px 16px !important;
`;

const Experience = ({ Data, i18, pageNumber, size }) => {
  const experiences = Data.experiences;
  let start = (pageNumber - 1) * size;
  let end = start + size;

  const timelineItems = experiences.slice(start, end).map((experience, index) => ({
    children: (
      <Row>
        <Col span={24}>
          <Typography.Title
            level={5}
            type="primary"
            style={{ textAlign: 'left' }}
          >
            {experience.company}
          </Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text type="primary">
            {experience.from} - {experience.to}
          </Typography.Text>
        </Col>
        <Col span={24}>
          <Typography.Text strong>{experience.position}</Typography.Text>
        </Col>
        <Col span={24}>
          <List
            split={false}
            dataSource={experience.responsibilities}
            renderItem={(item) => (
              <StyledListItem style={{ padding: '4px 16px' }}>
                <Typography.Text>
                  {item}
                </Typography.Text>
              </StyledListItem>
            )}
          />
          <Typography.Text strong>{i18.TIT_TECK_STACK}</Typography.Text>

          <List
            split={false}
            dataSource={experience.techStack}
            renderItem={(item) => (
              <StyledListItem style={{ padding: '4px 16px' }}>
                <Typography.Text style={{ fontSize: 12, }}>
                  {item}
                </Typography.Text>
              </StyledListItem>
            )}
          />
        </Col>
      </Row>
    ),
    key: index,
  }));

  return (
    <React.Fragment>
      <div className="section" id="experience">
        <Row>
          <Col span={24}>
            <Typography.Title level={4} style={{ textAlign: 'center' }}>
              {i18.TIT_EXPERIENCE}
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Typography.Text
              italic="true"
              style={{
                display: 'block',
                textAlign: 'center',
                marginBottom: '1rem',
                color: 'darkgray',
                fontSize: '0.8em',
              }}
            >
              {Data.getExperienceDuration()}
              <hr />
            </Typography.Text>
          </Col>
          <Col span={24}>
            <Timeline items={timelineItems} />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Experience;
